import type { InjectionKey, Ref } from 'vue';

/** ModalV2 and legacy modal stack base layer. */
export const MODAL_BASE_Z_INDEX = 200;

/** Foreground widgets temporarily yielding focus to a modal. */
export const BELOW_MODAL_Z_INDEX = MODAL_BASE_Z_INDEX - 1;

/** Popovers, block action menus, and other floating UI above modals. */
export const FLOATING_OVERLAY_Z_INDEX = 250;

/** Tooltips stay above modals but beneath popovers and dropdown menus. */
export const TOOLTIP_Z_INDEX = FLOATING_OVERLAY_Z_INDEX - 1;

/** AI assistant floating chat — always above modals and floating overlays. */
export const AI_ASSISTANT_Z_INDEX = 300;

/** Select modals that must render above the floating AI assistant shell. */
export const ABOVE_AI_ASSISTANT_MODAL_Z_INDEX = AI_ASSISTANT_Z_INDEX + 1;

/** Current modal layer for nested overlays rendered outside its DOM tree. */
export const modalLayerKey: InjectionKey<Readonly<Ref<number>>> =
  Symbol('modalLayer');
